
const bindToWindow = (key: string, value: unknown): void => {
    Object.assign(window, { [key]: value });
}

export default bindToWindow;